"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleButtonGroup = void 0;
var react_1 = __importStar(require("react"));
var ToggleButtonProvider_1 = require("../ToggleButtonProvider");
var css_1 = require("@emotion/css");
var styles = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n\n  button {\n    border-radius: 0;\n  }\n\n  button:first-of-type {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n\n  button:last-of-type {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n"], ["\n  display: flex;\n\n  button {\n    border-radius: 0;\n  }\n\n  button:first-of-type {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n\n  button:last-of-type {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n"])));
function ToggleButtonGroupInner(props, ref) {
    var value = props.value, onChange = props.onChange, children = props.children, userClassName = props.className, testId = props.testId, rest = __rest(props, ["value", "onChange", "children", "className", "testId"]);
    var className = (0, css_1.cx)(styles, userClassName, 'ds-toggle-button-group');
    return (react_1.default.createElement(ToggleButtonProvider_1.ToggleButtonProvider, { value: value, onChange: onChange },
        react_1.default.createElement("div", __assign({ ref: ref, className: className, role: "group", "data-testid": testId }, rest), children)));
}
ToggleButtonGroupInner.displayName = 'ToggleButtonGroup';
exports.ToggleButtonGroup = (0, react_1.forwardRef)(ToggleButtonGroupInner);
var templateObject_1;
